module.exports = __webpack_public_path__ + "static/envelope-beneath-1c6736c407acb498c9ba8ef493f1b01a.png";